import { routerGetCall } from '../../axios';

export const getLocationsUrl = `/accounts/locations`;

const getLocations = (state, params) => {
  const url = getLocationsUrl;
  return routerGetCall(state, url, params);
};
export default { getLocations };
